import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from "@mui/material/Typography";
import { IconButton, Grid, Box } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
// import { generateCSV } from "../../../utils/GenerateCSV";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import errorData from "../../common/twilio-error-codes.json"

const localeTheme = createTheme(
    {

    },
    localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function TabContainer({ children, dir, classes }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "created_on", numeric: false, disablePadding: false, label: "Date", padding: '8px', field: 'created_on' },
            { id: "receiver_name", numeric: false, disablePadding: false, label: "Name", padding: '8px', field: 'receiver_name' },
            { id: "phone", numeric: false, disablePadding: false, label: "Destination", padding: '8px', field: 'phone' },
            { id: "carrier", numeric: false, disablePadding: false, label: "Type", padding: '8px', field: 'carrier' },
            { id: "store", numeric: false, disablePadding: false, label: "Store", padding: '8px', field: 'name' },
            { id: "box", numeric: false, disablePadding: false, label: "Box", padding: '8px', field: 'name' },
            { id: "content", numeric: false, disablePadding: false, label: "Content", padding: '8px', field: 'content' },
            { id: "status", numeric: false, disablePadding: false, label: "Status", padding: '8px', field: 'status' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {
                                    <Tooltip
                                        title={t("Global.Label.Filter.Sort")}
                                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === row.field && sortId === row.id}
                                            direction={order}
                                            onClick={this.createSortHandler(row.id, row.field)}
                                        >
                                            {row.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);


const styles = theme => ({
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    rowheight: {
        height: '35px'
    },
    primaryButton: {
        background: '#6cca98',
        color: '#fff',
        '&:hover': {
            background: '#6cca98',
            color: '#fff',
        },
        '&:disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
            cursor: 'not-allowed',
            background: '#E4E5E8'
        },
    }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
let TransactionFilterObj = {
    store_ids: [],
    box_ids: [],
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: '',
    group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            isDataEmpty: true,
            selectedTab: 0,
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            contentData: '',
            queryId: "",
            groups: [],
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleBoxChange = this.handleBoxChange.bind(this);
        this.debouceTimeout = null;
    }

    componentDidMount() {
        TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(accounts => {
                const { t } = this.props;
                let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                const storelist = accounts.map(account => {
                    return { id: account.id, name: account.name };
                });

                const accountValues = All.concat(storelist);
                this.setState({ accountValues, parent_account_id: accountValues[0].id });
                this.BindBoxesbyStoreId(storelist.map(x => x.id));
                this.setState({ loader: false });
            });
        this.fetchSuggestions()
        this.BindGrid();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['created_on', 'phone', 'carrier', 'status'].includes(field)) {
            tablename = 'system_log';
        }
        if (['box'].includes(field)) {
            tablename = 'boxes';
        }
        if (['store'].includes(field)) {
            tablename = 'accounts';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        TransactionFilterObj.sortOrder = order;
        TransactionFilterObj.sortColumn = field;
        TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        const { data } = this.state;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        const { data } = this.state;
        TransactionFilterObj.pageNo = page;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        const { data } = this.state;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.pageSize = event.target.value;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    //Bind Boxes by store id
    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            })
                .then(response => {
                    try {
                        return response.json();
                    } catch (error) {
                        return null;
                    }
                })
                .then(data => {
                    const { t } = this.props;
                    let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                    const boxlist = data.map(account => {
                        return { id: account.id, name: account.name };
                    });
                    const boxvalues = All.concat(boxlist);
                    this.setState({ chipboxes: [] });
                    this.setState({ nboxes: [] });
                    this.setState({ boxvalues: boxvalues });
                    this.setState({ loader: false });
                });
        }
    }

    handleStoreChange = event => {
        const storeid = event.target.value;
        const storeids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.accountValues.length; i++) {
                processed.push(this.state.accountValues[i]);
            }
        }
        else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.accountValues.length; i++) {
                const element = storeid.findIndex(x => x.id === this.state.accountValues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.accountValues[i]);
                    processed.push(this.state.accountValues[i]);
                }
            }
        }
        else if (storeid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        }
        else if (storeid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
                else {

                }
            }
        }
        this.setState({ chipstores: chipprocessed });
        this.setState({ nstores: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    storeids.push(processed[i].id)
                }
            }
        }
        this.setState({ store_id: storeids });
        TransactionFilterObj.store_ids = storeids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindBoxesbyStoreId(storeids);
        this.BindGrid();
    };

    handleBoxChange = event => {
        const boxid = event.target.value;
        const boxids = [];

        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                processed.push(this.state.boxvalues[i]);
            }
        }
        else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                const element = boxid.findIndex(x => x.id === this.state.boxvalues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.boxvalues[i]);
                    processed.push(this.state.boxvalues[i]);
                }
            }
        }
        else if (boxid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        }
        else if (boxid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
                else {

                }
            }
        }
        this.setState({ chipboxes: chipprocessed });
        this.setState({ nboxes: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    boxids.push(processed[i].id)
                }
            }
        }
        this.setState({ box_id: boxids });
        TransactionFilterObj.box_ids = boxids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindGrid();
    };

    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ fromdate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };

    onToDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ todate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        this.setState({
            fromdate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = ''
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        this.setState({
            todate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = ''
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    handleUpdateMessageLog = () => {
        this.setState({ loader: true });
        const parent_id = sessionStorage.getItem('parentAccountId');
        const updateObj = {
            accountId: parent_id
        }
        fetch(process.env.REACT_APP_BASEURL + 'updateSystemLog', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateObj)
        })
            .then(response => {
                this.setState({ loader: false });
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    async BindGrid() {
        this.setState({ loader: true, data: null });
        await this.handleUpdateMessageLog();
        fetch(process.env.REACT_APP_BASEURL + 'getMessageLog', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        })
            .then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .then(uData => {
                if (uData && uData.results && uData.results.length > 0) {
                    this.setState({ data: uData.results, totalRecords: uData && uData.total });
                    setTimeout(() => {
                        this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false });
                    }, 5000)
                }
                else {
                    this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
                }
            });
    }

    handleContentClick = (event, data) => {
        event.preventDefault();
        const response = JSON.parse(data.response)
        const infoMessage = ![undefined, 'undefined', null, 'null', ''].includes(response.code) ? errorData.find((errorObj) => errorObj.code === response.code) : { description: data.status };
        const _data = {
            content: ![undefined, 'undefined', null, 'null', ''].includes(data.request_body) ? JSON.parse(data.request_body) : '',
            status: [null, 'null'].includes(infoMessage.description) ? infoMessage.message : infoMessage.description,
        }
        this.setState({ detailDialogOpen: true, contentData: _data })
    }

    handleContentClose = (event) => {
        event.preventDefault();
        this.setState({ detailDialogOpen: false, selectedTab: 0 })
    }

    handleTabChange = (event, index) => {
        this.setState({ selectedTab: index });
    };

    handleChangeIndex(index) {
        this.setState({ selectedTab: index });
    };

    getColor = (isOfflinePickup) => {
        if (isOfflinePickup === true)
            return { bgColor: '#00a7e1', fontColor: '#fff' };
        else
            return { bgColor: '#fff', fontColor: 'rgba(0, 0, 0, 0.87)' };
    };

    getLinkColor = (isOfflinePickup) => {
        if (isOfflinePickup === true)
            return '#fff';
        else
            return '#385cad';
    };

    handleUpdateLog = () => {
        this.setState({ loader: true });
        const parent_id = sessionStorage.getItem('parentAccountId');
        const updateObj = {
            accountId: parent_id
        }
        fetch(process.env.REACT_APP_BASEURL + 'updateSystemLog', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateObj)
        })
            .then(response => {
                this.setState({ loader: false });
                this.BindGrid();
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        TransactionFilterObj.group_id = event.target.value;
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    render() {
        const { classes, theme, t } = this.props;
        const { data, totalRecords, locale, queryId, groups } = this.state;
        return (
            <Paper>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                    <Dialog
                        open={this.state.detailDialogOpen}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{ style: { borderRadius: '5px', maxWidth: '100%', width: '50%' } }}
                    >
                        <AppBar position="static" color="default">
                            <Tabs
                                value={this.state.selectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant={null}
                            >
                                <Tab label="Content" />
                                <Tab label="Status" />
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={this.state.selectedTab}
                            onChangeIndex={() => this.handleChangeIndex}
                        >
                            <TabContainer dir={theme.direction}>
                                <DialogContent>
                                    {this.state.contentData.content}
                                </DialogContent>
                            </TabContainer>
                            <TabContainer dir={theme.direction}>
                                <DialogContent>
                                    {this.state.contentData.status}
                                </DialogContent>
                            </TabContainer>
                        </SwipeableViews>
                        <DialogActions>
                            <Button onClick={(e) => { this.handleContentClose(e) }} color="primary" className={classes.primaryButton}>
                                {t("Report.Picked.Temperature.CloseButton")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <Box component="div">
                    <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
                            <FormControl sx={{ width: '100%' }}>
                                <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip-store">{t("Report.Picked.StoreDropdown")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipstores}
                                    onChange={this.handleStoreChange}
                                    input={<Input id="select-multiple-chip-store" />}
                                    renderValue={selected => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map(value => (
                                                <Chip key={value.name} label={value.name} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {this.state.accountValues !== undefined && this.state.accountValues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nstores.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip">{t("Report.Picked.Box")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipboxes}
                                    onChange={this.handleBoxChange}
                                    input={<Input id="select-multiple-chip" />}
                                    renderValue={selected => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map(value => (
                                                <Chip key={value.id} label={value.name} className={classes.chip} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {this.state.boxvalues !== undefined && this.state.boxvalues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nboxes.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        keyboard
                                        value={this.state.fromdate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Picked.FromDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurfrom}
                                            />
                                        }
                                        onChange={this.onFromDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        keyboard
                                        value={this.state.todate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Picked.ToDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurtodate}
                                            />
                                        }
                                        onChange={this.onToDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={3} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    id="idsearchtxt"
                                    defaultValue=""
                                    value={this.state.searchtxt}
                                    label={t("Report.Picked.Search")}
                                    onChange={this.onSearchChange}
                                    variant="standard"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3} style={{ paddingLeft: '32px' }}>
                            <FormControl
                                variant='standard'
                                sx={{ m: '16px 0', minWidth: 347 }}
                            >
                                <InputLabel id='preferred-group-label'>
                                    {t('Group.User.GroupControlTitle')}
                                </InputLabel>
                                <Select
                                    labelId='preferred-group-label'
                                    id='preferred-group-select-standard'
                                    value={queryId}
                                    onChange={this.handleInputChange}
                                    variant='standard'
                                    label={t('Group.User.GroupControlTitle')}
                                >
                                    {groups.length > 0 &&
                                        groups.map((type, index) => (
                                            <MenuItem
                                                key={index}
                                                value={type.id}
                                                className={classes.locationType}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl fullWidth>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                            <IconButton onClick={this.handleUpdateLog}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="#727272" d="M13.5 2c-5.621 0-10.211 4.443-10.475 10h-3.025l5 6.625 5-6.625h-2.975c.257-3.351 3.06-6 6.475-6 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.863 0-3.542-.793-4.728-2.053l-2.427 3.216c1.877 1.754 4.389 2.837 7.155 2.837 5.79 0 10.5-4.71 10.5-10.5s-4.71-10.5-10.5-10.5z" />
                                </svg>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>
                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={TransactionFilterObj.sortOrder}
                            orderBy={TransactionFilterObj.sortColumn}
                            sortId={this.state.sortId}
                            onRequestSort={this.handleRequestSort}
                        />
                        <TableBody>
                            {!data ?
                                (<TableRow>
                                    <TableCell colSpan={21} style={{ textAlign: "center", padding: '10px 0px' }}>
                                        {this.state.isDataEmpty && t("Report.Picked.NoDataFound")}
                                    </TableCell>
                                </TableRow>)
                                : data.length && data.length > 0 &&
                                stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                                    .map(n => {
                                        return (
                                            <TableRow>
                                                <TableCell className={classes.padding10px} >{n.created_on ? this.convertToTimeZone(n && n.created_on) : ''}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.receiver_name}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.phone}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.carrier}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.store}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.box}</TableCell>
                                                <TableCell className={classes.padding10px} >{
                                                    <IconButton
                                                        onClick={(e) => this.handleContentClick(e, n)}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                            <path fill="#727272" d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" />
                                                        </svg>
                                                    </IconButton>}
                                                </TableCell>
                                                <TableCell className={classes.padding10px} >{[undefined, 'undefined', null, 'null', '', 400, '400'].includes(n.status) ? "Failed" : n.status.length > 0 && n.status.charAt(0).toUpperCase() + n.status.slice(1)}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRecords || 0}
                        rowsPerPage={TransactionFilterObj.pageSize}
                        page={TransactionFilterObj.pageNo}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/message-log/index.js